export default __webpack_public_path__ + "2fbda53b4accfd635064890287ecf53d.js";